

function Spook() {
    return (
        <div style={{ height: '90vh', alignContent: 'center' }}>
            <img class="bonezone" src="https://cdn.betterttv.net/emote/6172bd1f78e76c144f05de9c/3x.webp" alt="BONEZONE"/>
        </div>
    );
}

export default Spook;